import { connectHook } from 'app/common/components/connect-hook';
import { BooleanWidget } from './boolean-widget';
import { useBooleanWidget } from './boolean-widget-hook';

export default connectHook(BooleanWidget, useBooleanWidget);
